
export default function score(row, tab, value){

    const answers = row[tab];

    const total = answers.filter(a => ['OUI','NON'].includes(a)).length; 

    if(!total) return 0;

    const count = answers.filter(a => a === value).length;

    return Math.round(count / total * 100);
}